<div ngModalContent class="compareOffers-template">
  <h3 nxHeadline="subsection-medium" class="header">{{ 'offer.compare-offers.modal.header' | translate }}</h3>
  <ng-container *ngIf="(processKind$ | async) !== proccessType.RESIGNATION">
    <p nxCopytext="normal" class="description">{{ 'offer.compare-offers.modal.description' | translate }}</p>
    <p nxCopytext="normal" class="list-description">{{ 'coverage-information.description' | translate }}</p>
    <ul nxList>
      <li>{{ 'coverage-information.item1' | translate }}</li>
      <li>{{ 'coverage-information.item2' | translate }}</li>
      <li>{{ 'coverage-information.item3' | translate }}</li>
      <li>{{ 'coverage-information.item4' | translate }}</li>
    </ul>
  </ng-container>
  <div class="nx-margin-y-2m compare-offers-table">
    <qbe-package-table
      [labelCoverageProvided]="'offer.compare-offers.modal.table.labelCoverageProvided' | translate"
      [labelComfort]="(packageTableProps$ | async)?.labelComfort || ''"
      [labelPlus]="(packageTableProps$ | async)?.labelPlus || ''"
      [labelExtra]="(packageTableProps$ | async)?.labelExtra || ''"
      [labelMax]="(packageTableProps$ | async)?.labelMax || ''"
      [labelCoverageDefinitions]="'offer.compare-offers.modal.table.labelCoverageDefinitions' | translate"
      [variant]="packageTableVariant"
      [packageList]="(packageTableProps$ | async)?.packageList || []"
    ></qbe-package-table>
  </div>
  <p nxCopytext="normal" class="nx-margin-bottom-2m">
    {{ 'offer.compare-offers.modal.description1' | translate }}
  </p>
  <p nxCopytext="normal">
    {{ 'offer.compare-offers.modal.description2' | translate }}
  </p>
  <nx-link nxStyle="block" class="link">
    <a [href]="owuLink" target="_blank">
      <nx-icon name="download"></nx-icon>
      {{ 'offer.compare-offers.modal.btn' | translate }}
    </a>
  </nx-link>
  <div>
    <button
      *ngIf="isAppAgentOrAgency"
      nxPlainButton
      type="button"
      class="nx-margin-right-m offer-compare-offers-btn"
      (click)="showOfferLeafletModal()"
    >
      <nx-icon name="print-o" nxIconPositionStart></nx-icon>
      <span class="offer-compare-offers-btn-label"> {{ 'offer.compare-offers.modal.print-btn' | translate }} </span>
    </button>
  </div>

</div>
